import React, { useEffect, useMemo, useState } from "react";
import jwt_decode from "jwt-decode";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import LoadingBtn from "../../../Page/Widgets/LoadingBtn";

const AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

const URLPath = window.location.pathname;
const URLPathSplit = URLPath.split("/");
const total = URLPathSplit.length;
const URLPathName = URLPathSplit[1];

export function AsideMenu({ menu }) {
  const current_role = AuthDecode.currentData.roleid;
  const [acadMenu, setAcadMenu] = useState([]);
  const [reportMenu, setReportMenu] = useState([]);
  const menu_std_regulation = {
    ID: "1",
    Name: "Study Regulations",
    Description: "",
    PathURI: "#",
    ParentID: "0",
    Position: "4",
    IsActive: "1",
    Icon: '<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">\r\n    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\r\n        <rect x="0" y="0" width="24" height="24"/>\r\n        <path d="M13.6855025,18.7082217 C15.9113859,17.8189707 18.682885,17.2495635 22,17 C22,16.9325178 22,13.1012863 22,5.50630526 L21.9999762,5.50630526 C21.9999762,5.23017604 21.7761292,5.00632908 21.5,5.00632908 C21.4957817,5.00632908 21.4915635,5.00638247 21.4873465,5.00648922 C18.658231,5.07811173 15.8291155,5.74261533 13,7 C13,7.04449645 13,10.79246 13,18.2438906 L12.9999854,18.2438906 C12.9999854,18.520041 13.2238496,18.7439052 13.5,18.7439052 C13.5635398,18.7439052 13.6264972,18.7317946 13.6855025,18.7082217 Z" fill="#000000"/>\r\n        <path d="M10.3144829,18.7082217 C8.08859955,17.8189707 5.31710038,17.2495635 1.99998542,17 C1.99998542,16.9325178 1.99998542,13.1012863 1.99998542,5.50630526 L2.00000925,5.50630526 C2.00000925,5.23017604 2.22385621,5.00632908 2.49998542,5.00632908 C2.50420375,5.00632908 2.5084219,5.00638247 2.51263888,5.00648922 C5.34175439,5.07811173 8.17086991,5.74261533 10.9999854,7 C10.9999854,7.04449645 10.9999854,10.79246 10.9999854,18.2438906 L11,18.2438906 C11,18.520041 10.7761358,18.7439052 10.4999854,18.7439052 C10.4364457,18.7439052 10.3734882,18.7317946 10.3144829,18.7082217 Z" fill="#000000" opacity="0.3"/>\r\n    </g>\r\n</svg>',
    Type: "external",
    BgColor: null,
    RoleID: "1",
    Slug: "",
    URI: "https://drive.google.com/file/d/1h1BNMhW3cDeud-2NwNzXPakc0FK7C6Zq/view?usp=sharing",
    IsOpen: null,
    Child: [],
  };

  useMemo(() => {
    let computedData = Object.keys(menu.data).length > 0 ? menu.data.Academic : [];
    if (Object.values(computedData).length > 0) {
      const acad_Menu = computedData.filter((item) => item.Type !== "sub");
      const report_Menu = computedData.filter((item) => item.Type === "sub");
      // if (current_role === 1) {
        acad_Menu.push(menu_std_regulation);
      // }
      setAcadMenu(acad_Menu);
      setReportMenu(report_Menu);
    }

    return computedData;
  }, [menu.data]);

  return (
    <div
      className="aside-menu-wrapper flex-column-fluid"
      id="kt_aside_menu_wrapper"
    >
      <div
        id="kt_aside_menu"
        className="aside-menu my-4"
        data-menu-vertical="1"
        data-menu-scroll="1"
        data-menu-dropdown-timeout="500"
      >
        <ul className="menu-nav">
          <li
            className={
              "menu-item " +
              (URLPathName == "dashboard" ? "menu-item-active" : "")
            }
            aria-haspopup="true"
          >
            <Link to="/dashboard" className="menu-link">
              <span className="svg-icon menu-icon">
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <polygon points="0 0 24 0 24 24 0 24" />
                    <path
                      d="M12.9336061,16.072447 L19.36,10.9564761 L19.5181585,10.8312381 C20.1676248,10.3169571 20.2772143,9.3735535 19.7629333,8.72408713 C19.6917232,8.63415859 19.6104327,8.55269514 19.5206557,8.48129411 L12.9336854,3.24257445 C12.3871201,2.80788259 11.6128799,2.80788259 11.0663146,3.24257445 L4.47482784,8.48488609 C3.82645598,9.00054628 3.71887192,9.94418071 4.23453211,10.5925526 C4.30500305,10.6811601 4.38527899,10.7615046 4.47382636,10.8320511 L4.63,10.9564761 L11.0659024,16.0730648 C11.6126744,16.5077525 12.3871218,16.5074963 12.9336061,16.072447 Z"
                      fill="#000000"
                      fillRule="nonzero"
                    />
                    <path
                      d="M11.0563554,18.6706981 L5.33593024,14.122919 C4.94553994,13.8125559 4.37746707,13.8774308 4.06710397,14.2678211 C4.06471678,14.2708238 4.06234874,14.2738418 4.06,14.2768747 L4.06,14.2768747 C3.75257288,14.6738539 3.82516916,15.244888 4.22214834,15.5523151 C4.22358765,15.5534297 4.2250303,15.55454 4.22647627,15.555646 L11.0872776,20.8031356 C11.6250734,21.2144692 12.371757,21.2145375 12.909628,20.8033023 L19.7677785,15.559828 C20.1693192,15.2528257 20.2459576,14.6784381 19.9389553,14.2768974 C19.9376429,14.2751809 19.9363245,14.2734691 19.935,14.2717619 L19.935,14.2717619 C19.6266937,13.8743807 19.0546209,13.8021712 18.6572397,14.1104775 C18.654352,14.112718 18.6514778,14.1149757 18.6486172,14.1172508 L12.9235044,18.6705218 C12.377022,19.1051477 11.6029199,19.1052208 11.0563554,18.6706981 Z"
                      fill="#000000"
                      opacity="0.3"
                    />
                  </g>
                </svg>
              </span>
              <span className="menu-text">Dashboard</span>
            </Link>
          </li>

          {menu.loading ? (
            <li className="menu-item">
              <LoadingBtn />
            </li>
          ) : menu.message ? (
            <li className="menu-item">
              <i className="fa fa-times"></i> {menu.message}
            </li>
          ) : Object.keys(menu.data).length > 0 ? (
            // currentStatus !== status_id && (
            <>
              <li className="menu-section">
                <h4 className="menu-text">Academic</h4>
                <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
              </li>
              {Object.values(acadMenu).length > 0
                ? acadMenu.map(function (v) {
                    if (v.Child.length == 0) {
                      if (v.Position === "1" && current_role === 1) {
                        return <AttendanceMenu data={v} />;
                      }
                      return singleLink(v);
                    } else {
                      return dropdownLink(v);
                    }
                  })
                : ""}

              {Object.values(reportMenu).length > 0 ? (
                <>
                  <li className="menu-section">
                    <h4 className="menu-text">Report</h4>
                    <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
                  </li>
                  {reportMenu.map(function (v) {
                    if (v.Child.length == 0) {
                      return singleLink(v);
                    } else {
                      return dropdownLink(v);
                    }
                  })}
                </>
              ) : (
                ""
              )}

              {Object.values(menu.data.Config).length > 0 ? (
                <>
                  <li className="menu-section">
                    <h4 className="menu-text">Admin</h4>
                    <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
                  </li>
                  {menu.data.Config.map(function (a) {
                    if (a.Child.length == 0) {
                      return (
                        <li
                          key={a.ID}
                          className={
                            "menu-item " +
                            (URLPathName.split("-").join(" ") ==
                            a.Name.toLowerCase()
                              ? "menu-item-active"
                              : "")
                          }
                          aria-haspopup="true"
                        >
                          <Link to={a.PathURI} className="menu-link">
                            <span className="svg-icon menu-icon">
                              {parse(a.Icon)}
                            </span>
                            <span className="menu-text">{a.Name}</span>
                          </Link>
                        </li>
                      );
                    } else {
                      return (
                        <li
                          key={a.ID}
                          className={
                            "menu-item menu-item-submenu " +
                            (URLPathName.split("-").join(" ") ==
                            a.Name.toLowerCase()
                              ? "menu-item-active menu-item-open"
                              : "")
                          }
                          aria-haspopup="true"
                          data-menu-toggle="hover"
                        >
                          <a href="#" className="menu-link menu-toggle">
                            <span className="svg-icon menu-icon">
                              {parse(a.Icon)}
                            </span>
                            <span className="menu-text">{a.Name}</span>
                            <i className="menu-arrow"></i>
                          </a>

                          <div className="menu-submenu">
                            <i className="menu-arrow"></i>
                            <ul className="menu-subnav">
                              <li
                                className="menu-item menu-item-parent"
                                aria-haspopup="true"
                              >
                                <span className="menu-link">
                                  <span className="menu-text">{a.Name}</span>
                                </span>
                              </li>
                              {a.Child.map((k, index) => {
                                return (
                                  <li
                                    key={index}
                                    className={
                                      "menu-item " +
                                      (URLPathSplit[total - 1]
                                        .split("-")
                                        .join(" ") == k.Name.toLowerCase()
                                        ? "menu-item-active"
                                        : "")
                                    }
                                    aria-haspopup="true"
                                  >
                                    <Link to={k.PathURI} className="menu-link">
                                      <i className="menu-bullet menu-bullet-dot">
                                        <span></span>
                                      </i>
                                      <span className="menu-text">
                                        {k.Name}
                                      </span>
                                    </Link>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </li>
                      );
                    }
                  })}
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            // )
            ""
          )}
        </ul>
      </div>
    </div>
  );
}

export default AsideMenu;

const singleLink = (v) => {
  if(v?.Type === "external"){
    return (
      <li
        key={v.ID}
        className={"menu-item"}
        aria-haspopup="true"
      >
        <a href={v?.URI} target="_blank" className="menu-link">
          <span className="svg-icon menu-icon">{parse(v.Icon)}</span>
          <span className="menu-text">{v.Name}</span>
        </a>
      </li>
    )
  }else{
    return (
      <li
        key={v.ID}
        className={
          "menu-item " +
          (URLPathName.split("-").join(" ") == v.Name.toLowerCase()
            ? "menu-item-active"
            : "")
        }
        aria-haspopup="true"
      >
        <Link to={v.PathURI} className="menu-link">
          <span className="svg-icon menu-icon">{parse(v.Icon)}</span>
          <span className="menu-text">{v.Name}</span>
        </Link>
      </li>
    );
  }
};

const dropdownLink = (v) => {
  const sortedMenu = [...v.Child];
  sortedMenu.sort((a, b) => a.Position.localeCompare(b.Position));
  sortedMenu.forEach(sortChildren);

  return (
    <li
      key={v.ID}
      className={
        "menu-item menu-item-submenu " +
        (URLPathName.split("-").join(" ") == v.Name.toLowerCase()
          ? "menu-item-active menu-item-open"
          : "")
      }
      aria-haspopup="true"
      data-menu-toggle="hover"
    >
      <a href="#" className="menu-link menu-toggle">
        <span className="svg-icon menu-icon">{parse(v.Icon)}</span>
        <span className="menu-text">{v.Name}</span>
        <i className="menu-arrow"></i>
      </a>

      <div className="menu-submenu">
        <i className="menu-arrow"></i>
        <ul className="menu-subnav">
          <li className="menu-item menu-item-parent" aria-haspopup="true">
            <span className="menu-link">
              <span className="menu-text">{v.Name}</span>
            </span>
          </li>
          {sortedMenu.map((k, index) => {
            return (
              <li
                key={index}
                className={
                  "menu-item " +
                  (URLPathSplit[total - 1].split("-").join(" ") ==
                  k.Name.toLowerCase()
                    ? "menu-item-active"
                    : "")
                }
                aria-haspopup="true"
              >
                <Link to={k.PathURI} className="menu-link">
                  <i className="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span className="menu-text">{k.Name}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </li>
  );
};

function sortChildren(menu) {
  if (menu.Child) {
    menu.Child.sort((a, b) => a.Position.localeCompare(b.Position));
  }
}

const AttendanceMenu = ({ data }) => {
  console.log("attd:", data);
  return (
    <li
      className="menu-item menu-item-submenu"
      aria-haspopup="true"
      data-menu-toggle="hover"
    >
      <a href="#" className="menu-link menu-toggle">
        <span className="svg-icon menu-icon">
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <rect x="0" y="0" width="24" height="24" />
              <path
                d="M13.6855025,18.7082217 C15.9113859,17.8189707 18.682885,17.2495635 22,17 C22,16.9325178 22,13.1012863 22,5.50630526 L21.9999762,5.50630526 C21.9999762,5.23017604 21.7761292,5.00632908 21.5,5.00632908 C21.4957817,5.00632908 21.4915635,5.00638247 21.4873465,5.00648922 C18.658231,5.07811173 15.8291155,5.74261533 13,7 C13,7.04449645 13,10.79246 13,18.2438906 L12.9999854,18.2438906 C12.9999854,18.520041 13.2238496,18.7439052 13.5,18.7439052 C13.5635398,18.7439052 13.6264972,18.7317946 13.6855025,18.7082217 Z"
                fill="#000000"
              />
              <path
                d="M10.3144829,18.7082217 C8.08859955,17.8189707 5.31710038,17.2495635 1.99998542,17 C1.99998542,16.9325178 1.99998542,13.1012863 1.99998542,5.50630526 L2.00000925,5.50630526 C2.00000925,5.23017604 2.22385621,5.00632908 2.49998542,5.00632908 C2.50420375,5.00632908 2.5084219,5.00638247 2.51263888,5.00648922 C5.34175439,5.07811173 8.17086991,5.74261533 10.9999854,7 C10.9999854,7.04449645 10.9999854,10.79246 10.9999854,18.2438906 L11,18.2438906 C11,18.520041 10.7761358,18.7439052 10.4999854,18.7439052 C10.4364457,18.7439052 10.3734882,18.7317946 10.3144829,18.7082217 Z"
                fill="#000000"
                opacity="0.3"
              />
            </g>
          </svg>
        </span>
        <span className="menu-text">Attendance</span>
        <i className="menu-arrow"></i>
      </a>
      <div className="menu-submenu">
        <i className="menu-arrow"></i>
        <ul className="menu-subnav">
          <li className="menu-item menu-item-parent" aria-haspopup="true">
            <span className="menu-link">
              <span className="menu-text">Attendance</span>
            </span>
          </li>
          <li className="menu-item" aria-haspopup="true">
            <Link className="menu-link" to={data?.URI || "#"}>
              <i className="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span className="menu-text">{data?.Name || ""}</span>
            </Link>
          </li>
          <li className="menu-item" aria-haspopup="true">
            <a
              href="https://docs.google.com/forms/d/1hgz0VxRT4utQnoC12NofpMMHuT5WyK_fekqAcyDmDsk/viewform?edit_requested=true&pli=1"
              className="menu-link"
              target="_blank"
            >
              <i className="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span className="menu-text">Absence Permission Form</span>
            </a>
          </li>
        </ul>
      </div>
    </li>
  );
};
